export default __webpack_public_path__ + "locales/lv/EmptyTrashDialog.json?hash=b3d0ba2a9aefcdbf08d73efb702d9651";